import HyperwolfMainBanners from 'layouts/hyperwolf/manageHyperwolfBanners'
import React from 'react'

const HomepageBanner = () => {
  return (
    <HyperwolfMainBanners />
  )
}

export default HomepageBanner
